export default function LandingTextImage({ title, text, image, textRight, alt }) {
    return ( <>
        {!textRight ? (
            <div className='md:flex md:justify-around w-2/3 mx-auto mt-10' data-aos="fade-up" data-aos-duration="1000">
                <div className=' text-left flex flex-col justify-center text-white'>
                    <h3 className='uppercase font-bold text-2xl md:text-4xl mb-5'>{title}</h3>
                {text}
                </div>
                <div className='md:w-1/4 mr-20 mt-5 md:mt-0'>
                    <img src={image} alt={alt} />
                </div>
            </div>
        ) : (
            <div className='md:flex md:justify-around w-2/3 mx-auto mt-10' data-aos="fade-up" data-aos-duration="1000">
                <div className='md:w-1/4 mr-20 mt-5 md:mt-0 hidden md:block'>
                    <img src={image} alt={alt} />
                </div>
                <div className=' text-left flex flex-col justify-center text-white'>
                    <h3 className='uppercase font-bold text-2xl md:text-4xl mb-5'>{title}</h3>
                    {text}
                </div>
                <div className='md:w-1/4 mr-20 mt-5 md:mt-0 md:hidden'>
                    <img src={image} alt={alt} />
                </div>
            </div>
        )}
    </>
    )
}